import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import ScrollToTop from "@/components/ScrollToTop";
import Analytics from "@/components/Analytics";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import CategoryPage from "@/pages/CategoryPage";
import ServiceDetail from "@/pages/ServiceDetail";
import LocationResolver from "@/pages/LocationResolver";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Applications from "@/pages/Applications";
import ApplicationResolver from "@/pages/ApplicationResolver";
import Contact from "@/pages/Contact";
import Appointment from "@/pages/Appointment";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AppointmentsAdmin from "@/pages/admin/AppointmentsAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import CollectionAdmin from "@/pages/admin/CollectionAdmin";
import SeoHubAdmin from "@/pages/admin/SeoHubAdmin";

function LegacyApplicationRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/uygulamalar/${slug}`} replace />;
}

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Analytics />
          <Toaster theme="dark" position="top-right" richColors closeButton />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/hizmetler" element={<Services />} />
              <Route path="/hizmetler/kategori/:slug" element={<CategoryPage />} />
              <Route path="/hizmetler/:slug" element={<ServiceDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/uygulamalar" element={<Applications />} />
              <Route path="/uygulamalar/:slug" element={<ApplicationResolver />} />
              {/* Legacy → 301-style client redirects (old "Vaka Çalışmaları" routes) */}
              <Route path="/vaka-calismalari" element={<Navigate to="/uygulamalar" replace />} />
              <Route path="/vaka-calismalari/:slug" element={<LegacyApplicationRedirect />} />
              <Route path="/iletisim" element={<Contact />} />
              <Route path="/randevu" element={<Appointment />} />
              <Route path="/gizlilik-politikasi" element={<Legal slug="gizlilik-politikasi" />} />
              <Route path="/kvkk-aydinlatma-metni" element={<Legal slug="kvkk-aydinlatma-metni" />} />
              <Route path="/cerez-politikasi" element={<Legal slug="cerez-politikasi" />} />
              <Route path="/:slug" element={<LocationResolver />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="seo-hub" element={<SeoHubAdmin />} />
              <Route path="randevular" element={<AppointmentsAdmin />} />
              <Route path="ayarlar" element={<SettingsAdmin />} />
              <Route path="c/:collection" element={<CollectionAdmin />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
